import React__default, { useMemo } from 'react';
import { g as getTranslationComponent } from '../../i18n/FeedbackFormTranslation/index-FZfSYq_3.js';
import { i as internalLoadTranslations } from './internalLoadTranslations-CvbqT5Io.js';
import { c as convertToPantherLocale } from './convertToPantherLocale-BIgO7g9P.js';
import { I as IntlProvider$1 } from '../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-CX9yP88S-B6OFY9Vv.js';

const DEFAULT_LOCALE = 'en-US';
const getTranslationProviderComponent = translationMap => ({
  children
}) => children(translationMap);
const IntlProvider = ({
  locale = DEFAULT_LOCALE,
  onLoadFailed,
  fallback,
  translationMap,
  children
}) => {
  const translations = useMemo(() => {
    if (translationMap) {
      return {
        // @ts-ignore
        component: getTranslationProviderComponent(translationMap),
        locale
      };
    }
    return getTranslationComponent(locale);
  }, [locale, translationMap]);
  return /*#__PURE__*/React__default.createElement(IntlProvider$1, {
    translations: translations,
    onError: error => {
      if (onLoadFailed) {
        onLoadFailed(error);
      }
    },
    resetKey: locale,
    fallback: fallback
  }, children);
};
function loadTranslations(locale) {
  return internalLoadTranslations(convertToPantherLocale(locale));
}

export { IntlProvider as I, loadTranslations as l };
//# sourceMappingURL=i18n-Z3LCXHeB.js.map
